import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, IconButton, Typography, Box } from '@mui/material';

import dayjs from 'dayjs';
import { Wheels } from '../../domain/wheels';

import EditIcon from '../Icons/EditIcon';
import DeleteIcon from '../Icons/DeleteIcon';

interface Props {
  wheels: Wheels;
  onEdit: () => void;
  onRemove: () => void;
}

export const WheelsShoppingCartSummary = ({ wheels, onEdit, onRemove }: Props) => {
  const { t } = useTranslation();

  return (
    <Stack gap="16px" padding="16px 0px" direction="column" borderBottom="1px solid rgba(0, 0, 0, 0.12)">
      <Stack direction="column">
        <Stack width="100%" direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="body1" color="secondary.light" fontWeight={700}>
            {t('wheels_summary.title')}
          </Typography>
          <Stack direction="row">
            {false && (
              <IconButton onClick={onEdit}>
                <EditIcon fontSize="small" />
              </IconButton>
            )}
            <IconButton onClick={onRemove}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Stack>
        <Stack width="100%">
          <Stack width="fit-content">
            <Typography fontWeight={500}>
              {/* Not asserting the zoneDisplay property because of potential 
                  saved data before the property was added to the app*/}
              {wheels?.zoneDisplay ||  (wheels.zone).toUpperCase()}  - {wheels.city}, {wheels.address}, {wheels.zipcode}
            </Typography>

            <Stack flexDirection="row" alignItems="center" gap={1}>
              <Typography fontSize={12} fontWeight={500}>
                {dayjs(wheels.startDate).format('MMMM DD')}
              </Typography>
              <Box width={4} height={4} bgcolor="#EF60A3" borderRadius={2} />
              <Typography fontSize={12} fontWeight={400}>
                {wheels.startTime} hrs
              </Typography>
            </Stack>

            <Typography mt={1} fontSize={12} fontWeight={500}>
              {wheels.vehicle}
            </Typography>
          </Stack>

          <Stack flexDirection="row" justifyContent="flex-end" mt={1}>
            <Typography fontSize={12} fontWeight={500}>
              ${wheels.Amount.toFixed(2)} USD
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
